export const GOOGLE_PLAY_APP_URL = 'https://play.google.com/store/apps/details?id=com.camdiab.fx_alert.mmoll&hl=en_GB';
export const APPLE_APP_STORE_URL = 'https://apps.apple.com/gb/app/camaps-fx-mmol-l/id6504254394';
